import {
  AdjustmentsHorizontalIcon,
  ListBulletIcon,
  BellAlertIcon,
  AcademicCapIcon,
} from '@heroicons/react/24/outline';

const points = [
  {
    icon: AdjustmentsHorizontalIcon,
    title: 'Personalized recommendations',
    description: 'Tailored to your home and daily routines, uniquely yours.',
  },
  {
    icon: ListBulletIcon,
    title: 'Prioritized next steps',
    description: 'Start with what matters most tomorrow morning, one step at a time.',
  },
  {
    icon: BellAlertIcon,
    title: 'Gentle accountability',
    description: 'Consistent follow-through that supports you, gently and reliably.',
  },
  {
    icon: AcademicCapIcon,
    title: 'Practical education',
    description: 'Simple explanations for why each change makes daily life easier and safer.',
  },
];

const GuidanceSection = () => {
  return (
    <div className="py-20 lg:py-28 bg-muted/20">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-5 gap-12 items-center">
            {/* Left: headline and context */}
            <div className="lg:col-span-2 space-y-6">
              <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
                Knowing What to Do Matters More Than{' '}
                <span className="text-primary">Knowing Something Is Wrong</span>
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Information alone doesn't create confidence. Clear next steps do.
              </p>
              <p className="text-primary font-semibold text-lg">
                This is how prevention becomes part of everyday life.
              </p>
            </div>

            {/* Right: guidance cards */}
            <div className="lg:col-span-3 grid sm:grid-cols-2 gap-5">
              {points.map((point, index) => (
                <div
                  key={point.title}
                  className="group p-6 rounded-2xl bg-background border border-border shadow-sm hover:shadow-lg hover:border-primary/20 transition-all duration-300 hover:-translate-y-0.5"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary/15 transition-colors">
                      <point.icon className="w-5 h-5 text-primary" />
                    </div>
                    <h3 className="font-semibold text-foreground">{point.title}</h3>
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed">{point.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuidanceSection;
